const lib = {
	selectors: {
		integrations: '.integrations',
		tile: '.tile',
		thumb: '.integrations__thumb',
	},
};

const observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			// Loop through each tile in the integration container
			entry.target.querySelectorAll(lib.selectors.tile).forEach((tile) => {
				const thumb = tile.querySelector(lib.selectors.thumb);
				// If the thumb has a data-src attribute, set the --src property to the value of the data-src attribute
				if (thumb && thumb.getAttribute('data-src')) {
					thumb.style.setProperty('--src', `url(${thumb.getAttribute('data-src')})`);
					thumb.removeAttribute('data-src');
				}
			});

			observer.unobserve(entry.target);
		}
	});
});

document.querySelectorAll(lib.selectors.integrations).forEach((integrationContainer) => {
	observer.observe(integrationContainer);
});
